import React from "react";

const Footer = () => {
  return (
    <div>
      <p>&copy; 2021-22, Built with ❤️</p>
    </div>
  );
};

export default Footer;
